import { allIncomeClassificators } from "../../common/baseOptions"
import { Classificator } from "../../common/types/Classificator"
import { Indicator } from "../../common/types/Indicator"
import { BudgetType, Month } from "../../common/types/roots/fields"
import { Template } from "../../common/types/Template"
import { Report127FilterSettings } from "./settings/Report127FilterSettings"
import { cloneDeep } from 'lodash'

export const report127Expenses: Classificator[] = [
    { key: 'gr',  active: false, selected: [] },
    { key: 'pgr', active: false, selected: [] },
    { key: 'abp', active: false, selected: [] },
    { key: 'prg', active: false, selected: [] },
    { key: 'ppr', active: false, selected: [] },
    { key: 'pcl', active: false, selected: [] },
    { key: 'spf', active: false, selected: [] }
]
export const report127Indicators: Indicator[] = [
    { key: 'utv', active: true },
    { key: 'utch', active: true },
    { key: 'plg', active: true },
    { key: 'plgs', active: true }, // Родительнский показатель для plgp, plgo
    { key: 'obz', active: true },
    { key: 'nobz', active: true },
    { key: 'sumrg', active: true },
    { key: 'percentage1', active: true },
    { key: 'percentage2', active: true }
]

/** Полный */
export const get127BatchFullTemplate = (date: Date): Template => {
    const fs: Report127FilterSettings = {
        reportName: '1-27',

        reportType: 'REGULATED',
        classificationType: 'MIXED',
        dataSource: 'LOADER',
        periodicity: 'MONTH',

        regions: [],
        mutuallyRedeeming: 'WITH',
        mutuallyRedeemingLevels: [],
        budgetTypes: [],
        measureUnit: 'THOUSAND',
        budgetStructure: 'WITH',
        developType: null,
        year: date.getFullYear(),
        month: (date.getMonth()) as Month,
        separateByRegion: false,
        roundUpTo: null,
        isTree: true,
        incomeTotal: false,
        expenseTotal: false,
        incomes: cloneDeep(allIncomeClassificators).map(it => {it.active = true; return it }),
        expenseType: 'FUNCTIONAL',
        expenses: cloneDeep(report127Expenses).map(it => {it.active = true; return it }),
        indicators: cloneDeep(report127Indicators)
    }

    const template: Template = {
        id: null,
        name: 'full',
        excelName: null,
        description: 'budget_execution_reporting_package',
        category: '70',
        regions: [],
        userId: '',
        filterSettings: fs
    }

    return template
}

/** Агрегированный */
export const get127BatchAggregatedTemplate = (date: Date): Template => {
    const fs: Report127FilterSettings = {
        reportName: '1-27',

        reportType: 'REGULATED',
        classificationType: 'MIXED',
        dataSource: 'LOADER',
        periodicity: 'MONTH',

        regions: [],
        mutuallyRedeeming: 'WITH',
        mutuallyRedeemingLevels: [],
        budgetTypes: [],
        measureUnit: 'THOUSAND',
        budgetStructure: 'WITH',
        developType: null,
        year: date.getFullYear(),
        month: (date.getMonth()) as Month,
        separateByRegion: false,
        roundUpTo: null,
        isTree: true,
        incomeTotal: false,
        expenseTotal: false,
        incomes: cloneDeep(allIncomeClassificators).map(it => {
            if (it.key === 'kat') {
                it.active = true
            }
            return it
        }),
        expenseType: 'FUNCTIONAL',
        expenses: cloneDeep(report127Expenses).map(it => {
            if (it.key === 'gr') {
                it.active = true
            }
            return it
        }),
        indicators: cloneDeep(report127Indicators)
    }

    const template: Template = {
        id: null,
        name: 'aggregated',
        excelName: null,
        description: 'budget_execution_reporting_package',
        category: '70',
        regions: [],
        userId: '',
        filterSettings: fs
    }

    return template
}

/** Экономический */
export const get127BatchEconomicalTemplate = (date: Date): Template => {
    const fs: Report127FilterSettings = {
        reportName: '1-27',

        reportType: 'REGULATED',
        classificationType: 'MIXED',
        dataSource: 'LOADER',
        periodicity: 'MONTH',

        regions: [],
        mutuallyRedeeming: 'WITHOUT',
        mutuallyRedeemingLevels: [],
        budgetTypes: [],
        measureUnit: 'THOUSAND',
        budgetStructure: 'WITHOUT',
        developType: null,
        year: date.getFullYear(),
        month: (date.getMonth()) as Month,
        separateByRegion: false,
        roundUpTo: null,
        isTree: true,
        incomeTotal: true,
        expenseTotal: true,
        incomes: cloneDeep(allIncomeClassificators).map(it => {
            it.active = true
            return it
        }),
        expenseType: 'ECONOMICAL',
        expenses: cloneDeep(allIncomeClassificators).map(it => {
            it.active = true
            return it
        }),
        indicators: cloneDeep(report127Indicators)
    }

    const template: Template = {
        id: null,
        name: 'economic',
        excelName: null,
        description: 'budget_execution_reporting_package',
        category: '70',
        regions: [],
        userId: '',
        filterSettings: fs
    }

    return template
}

/** Текущие программы */
export const get127BatchCurrentProgramsTemplate = (date: Date): Template => {
    const fs: Report127FilterSettings = {
        reportName: '1-27',

        reportType: 'REGULATED',
        classificationType: 'MIXED',
        dataSource: 'LOADER',
        periodicity: 'MONTH',

        regions: [],
        mutuallyRedeeming: 'WITH',
        mutuallyRedeemingLevels: [],
        budgetTypes: [],
        measureUnit: 'THOUSAND',
        budgetStructure: 'WITHOUT',
        developType: 0,
        year: date.getFullYear(),
        month: (date.getMonth()) as Month,
        separateByRegion: false,
        roundUpTo: null,
        isTree: true,
        incomeTotal: false,
        expenseTotal: true,
        incomes: cloneDeep(allIncomeClassificators),
        expenseType: 'FUNCTIONAL',
        expenses: cloneDeep(report127Expenses).map(it => {
            it.active = true
            return it
        }),
        indicators: cloneDeep(report127Indicators)
    }

    const template: Template = {
        id: null,
        name: 'current_programs',
        excelName: null,
        description: 'budget_execution_reporting_package',
        category: '70',
        regions: [],
        userId: '',
        filterSettings: fs
    }

    return template
}

/** Программы развития */
export const get127BatchDevelopProgramsTemplate = (date: Date): Template => {
    const fs: Report127FilterSettings = {
        reportName: '1-27',

        reportType: 'REGULATED',
        classificationType: 'MIXED',
        dataSource: 'LOADER',
        periodicity: 'MONTH',

        regions: [],
        mutuallyRedeeming: 'WITH',
        mutuallyRedeemingLevels: [],
        budgetTypes: [],
        measureUnit: 'THOUSAND',
        budgetStructure: 'WITHOUT',
        developType: 1,
        year: date.getFullYear(),
        month: (date.getMonth()) as Month,
        separateByRegion: false,
        roundUpTo: null,
        isTree: true,
        incomeTotal: false,
        expenseTotal: true,
        incomes: cloneDeep(allIncomeClassificators),
        expenseType: 'FUNCTIONAL',
        expenses: cloneDeep(report127Expenses).map(it => {
            it.active = true
            return it
        }),
        indicators: cloneDeep(report127Indicators)
    }

    const template: Template = {
        id: null,
        name: 'development_programs',
        excelName: null,
        description: 'budget_execution_reporting_package',
        category: '70',
        regions: [],
        userId: '',
        filterSettings: fs
    }

    return template
}

/** Исполнение бюджета (Поступления) */
export const get127BatchIncomeExecutionTemplate = (date: Date): Template => {
    const activeIncomes = cloneDeep(allIncomeClassificators).map(it => {
        it.active = true
        return it
    })

    const fs: Report127FilterSettings = {
        reportName: '1-27',

        reportType: 'REGULATED',
        classificationType: 'MIXED',
        dataSource: 'LOADER',
        periodicity: 'MONTH',

        regions: [],
        mutuallyRedeeming: 'WITH',
        mutuallyRedeemingLevels: [],
        budgetTypes: [],
        measureUnit: 'THOUSAND',
        budgetStructure: 'WITHOUT',
        developType: null,
        year: date.getFullYear(),
        month: (date.getMonth()) as Month,
        separateByRegion: false,
        roundUpTo: null,
        isTree: true,
        incomeTotal: false,
        expenseTotal: false,
        incomes: activeIncomes,
        expenseType: 'FUNCTIONAL',
        expenses: cloneDeep(report127Expenses),
        indicators: cloneDeep(report127Indicators)
    }

    const template: Template = {
        id: null,
        name: 'budget_execution_incomes',
        excelName: null,
        description: 'budget_execution_reporting_package',
        category: '70',
        regions: [],
        userId: '',
        filterSettings: fs
    }

    return template
}

/** Исполнение бюджета (Расходы) */
export const get127BatchExpenseExecutionTemplate = (date: Date): Template => {
    const fs: Report127FilterSettings = {
        reportName: '1-27',

        reportType: 'REGULATED',
        classificationType: 'MIXED',
        dataSource: 'LOADER',
        periodicity: 'MONTH',

        regions: [],
        mutuallyRedeeming: 'WITH',
        mutuallyRedeemingLevels: [],
        budgetTypes: [],
        measureUnit: 'THOUSAND',
        budgetStructure: 'WITHOUT',
        developType: null,
        year: date.getFullYear(),
        month: (date.getMonth()) as Month,
        separateByRegion: false,
        roundUpTo: null,
        isTree: true,
        incomeTotal: false,
        expenseTotal: false,
        incomes: cloneDeep(allIncomeClassificators),
        expenseType: 'FUNCTIONAL',
        expenses: cloneDeep(report127Expenses).map(it => {
            it.active = true
            return it
        }),
        indicators: cloneDeep(report127Indicators)
    }

    const template: Template = {
        id: null,
        name: 'budget_execution_expenses',
        excelName: null,
        description: 'budget_execution_reporting_package',
        category: '70',
        regions: [],
        userId: '',
        filterSettings: fs
    }

    return template
}

/** Исполнение бюджета (В разрезе АБП) */
export const get127BatchAbpExecutionTemplate = (date: Date): Template => {
    const fs: Report127FilterSettings = {
        reportName: '1-27',

        reportType: 'REGULATED',
        classificationType: 'MIXED',
        dataSource: 'LOADER',
        periodicity: 'MONTH',

        regions: [],
        mutuallyRedeeming: 'WITH',
        mutuallyRedeemingLevels: [],
        budgetTypes: [],
        measureUnit: 'THOUSAND',
        budgetStructure: 'WITHOUT',
        developType: null,
        year: date.getFullYear(),
        month: (date.getMonth()) as Month,
        separateByRegion: false,
        roundUpTo: null,
        isTree: true,
        incomeTotal: false,
        expenseTotal: false,
        incomes: cloneDeep(allIncomeClassificators),
        expenseType: 'FUNCTIONAL',
        expenses: cloneDeep(report127Expenses).map(it => {
            if (it.key === 'abp') {
                it.active = true
            }
            return it
        }),
        indicators: cloneDeep(report127Indicators)
    }

    const template: Template = {
        id: null,
        name: 'budget_execution_by_abp',
        excelName: null,
        description: 'budget_execution_reporting_package',
        category: '70',
        regions: [],
        userId: '',
        filterSettings: fs
    }

    return template
}
